import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import AvailableJobCard, { AvailableJobCardProps } from './AvailableJobCard';

interface AvailableJobsProps extends Omit<AvailableJobCardProps, 'name' | 'className'> {
  items: string[];
  headline: React.ReactElement;
  itemsClassName?: string;
  cardClassName?: string;
}

const AvailableJobs: React.FC<AvailableJobsProps> = ({ items, headline, itemsClassName, cardClassName, ...rest }) => (
  <div className='flex flex-col items-center'>
    {headline}
    <div className={twMerge(clsx('flex w-full flex-col justify-center gap-4 lg:flex-row lg:flex-wrap', itemsClassName))}>
      {items.map(item => (
        <AvailableJobCard className={cardClassName} key={item} name={item} {...rest} />
      ))}
    </div>
  </div>
);

export default AvailableJobs;
